// extracted by mini-css-extract-plugin
export default {"container":"appreciation-screen_container__RAkwY","title":"appreciation-screen_title__9XDLQ"};